export default __webpack_public_path__ + "static/media/Ballroll_00339.1fd59004.png";